'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'user-logged-in',
    /* eslint-disable max-len */
    shape: _react2.default.createElement(
        'g',
        { id: 'The-Standard', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
        _react2.default.createElement(
            'g',
            { id: 'User-Icons', transform: 'translate(-15.000000, -11.000000)' },
            _react2.default.createElement(
                'g',
                { transform: 'translate(15.000000, 11.000000)' },
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement(
                        'g',
                        { transform: 'translate(4.000000, 18.000000)', fill: '#FFFFFF' },
                        _react2.default.createElement(
                            'g',
                            null,
                            _react2.default.createElement('path', { d: 'M0.473053435,7.77903357 C3.22457422,10.9695759 7.36699524,13 12,13 C16.6330048,13 20.7754258,10.9695759 23.5269466,7.77903357 C22.3318646,4.65683912 19.0339244,2.08350231 15.500861,1 C14.4543867,1.87178687 13.2503324,2.41055245 12,2.41055245 C10.7496676,2.41055245 9.54561327,1.87178687 8.49913902,1 L8.49913902,1 C4.9660756,2.08350231 1.66813541,4.65683912 0.473053435,7.77903357 Z', id: 'Combined-Shape' }),
                            _react2.default.createElement('path', { d: 'M12,1 C15.3137085,1 18,-3.6862915 18,-7 C18,-10.3137085 15.3137085,-13 12,-13 C8.6862915,-13 6,-10.3137085 6,-7 C6,-3.6862915 8.6862915,1 12,1 Z', id: 'Oval-2' })
                        )
                    )
                )
            )
        )
    ),
    /* eslint-enable max-len */
    viewbox: '0 0 32 32',
    label: 'User logged in'
};
//# sourceMappingURL=user-logged-in.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/lib/cjs/svg/user-logged-in.js
 ** module id = 478
 ** module chunks = 1
 **/